import React from 'react';
import Hero from '../components/Hero';
import FromIdeaToImpact from '../components/FromIdeaToImpact';
import WhatWeDo from '../components/WhatWeDo';
import ImpactStories from '../components/ImpactStories';
import Partnership from '../components/Partnership';
import CallToAction from '../components/CallToAction';
import SEO from '../components/SEO';

const Home = () => (
  <div className="home-page">
    <SEO
      title="Home"
      description="YOCILAB — Driving youth employment and inclusive economic development across Africa through skills, innovation, and opportunity."
    />
    <Hero />
    <WhatWeDo />
    <FromIdeaToImpact />
    <ImpactStories />
    <Partnership />
    <CallToAction />
  </div>
);

export default Home;